import { render, staticRenderFns } from "./mobile-footer-panel.vue?vue&type=template&id=531e063d&scoped=true"
import script from "./mobile-footer-panel.vue?vue&type=script&lang=js"
export * from "./mobile-footer-panel.vue?vue&type=script&lang=js"
import style0 from "./mobile-footer-panel.vue?vue&type=style&index=0&id=531e063d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531e063d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531e063d')) {
      api.createRecord('531e063d', component.options)
    } else {
      api.reload('531e063d', component.options)
    }
    module.hot.accept("./mobile-footer-panel.vue?vue&type=template&id=531e063d&scoped=true", function () {
      api.rerender('531e063d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mobile-footer-panel.vue"
export default component.exports